import React from 'react';

export default function Terms() {
    return (
        <>
            <div>
                <h1>Terms and Conditions.</h1>
                <p>Lorem ipsum Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.Terms and Conditions.</p>
            </div>
        </>
    );
}